module.exports = __webpack_public_path__ + "img/finish.842f58bc.svg";